import { Injectable } from '@angular/core';

import { bemTiposStorage } from "./data.service";
import {AutoCompleteService} from "../../../shared/components/autocomplete/autocomplete.service";
import {ModeloNavigationService} from "../../modelos/shared/modelo-navigation.service";
import {ModeloService} from "../../modelos/shared/modelo.service";
import {modelosStorage} from "../../modelos/shared/data.service";

@Injectable()
export class BemTiposService {

  constructor(
    private _modeloNavigationService: ModeloNavigationService,
    private _modeloService: ModeloService,

    private _autocompleteService: AutoCompleteService
  ) { }

  //session
  setSessionStorage(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(bemTiposStorage + '-new', object);
  }

  getSessionStorage() {
    var item: string = sessionStorage.getItem(bemTiposStorage + "-new");
    return JSON.parse(item);
  }

  clearSessionStorage() {
    sessionStorage.removeItem(bemTiposStorage + "-new");
  }

  setSessionStorageFatherModule(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(bemTiposStorage + '-father', object);
  }

  getSessionStorageFatherModule() {
    var item: string = sessionStorage.getItem(bemTiposStorage + "-father");
    return JSON.parse(item);
  }

  clearSessionStorageFatherModule() {
    sessionStorage.removeItem(bemTiposStorage + "-father");
  }

  returnToOtherForm(otherForm: string, Response: any) {
    if(Response) {
      var otherFormObject: any;

      if (otherForm === modelosStorage) {
        otherFormObject = this._modeloService.getSessionStorage();
        otherFormObject.tipoBem = Response;
        this._modeloService.setSessionStorage(otherFormObject);
      }
    }

    this._autocompleteService.clearSessionStorage(bemTiposStorage);

    if (otherForm === modelosStorage) {
      otherFormObject = this._modeloService.getSessionStorage();
      if (otherFormObject.id) {
        this._modeloNavigationService.goToEdit(otherFormObject.id);
      } else {
        this._modeloNavigationService.goToNew();
      }
    }
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-tipos/shared/bem-tipos.service.ts
 **/